/**
 * Created by tofaelraju on 10/15/17.
 */
import React from 'react';
import {spacing, typography} from 'material-ui/styles';

const styles = {
  cursor: 'pointer',
  fontSize: 22,
  color: typography.textFullWhite,
  lineHeight: `${spacing.desktopKeylineIncrement}px`,
  fontWeight: typography.fontWeightLight,
  paddingLeft: 40,
  height: 56
}

const AppTitle =()=> <div style={styles}>Olwel Admin</div>

export default AppTitle;


// WEBPACK FOOTER //
// ./src/screens/layout/app-title.js